var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tags-panel w-full" }, [
    _c("div", { staticClass: "tags-panel__container" }, [
      _c(
        "div",
        { staticClass: "tags-panel__column tags-panel__column--full" },
        [
          _c(
            "div",
            { staticClass: "flex w-full justify-between items-center" },
            [
              _c("div", { staticClass: "w-full" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap w-full justify-between" },
                  [
                    _c(
                      "div",
                      { staticClass: "tags-panel__action control-label" },
                      [_vm._v(_vm._s(_vm.action))]
                    ),
                    _vm._v(" "),
                    _vm._t("default"),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.selectedTags
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "inline-flex items-baseline flex-wrap tags-panel__tags",
                      },
                      [
                        _vm._l(_vm.selectedTags, function (tag) {
                          return [
                            _c(
                              "span",
                              { key: tag.id, staticClass: "tags-panel__tag" },
                              [_vm._v(_vm._s(tag.name))]
                            ),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.isUpdatingExistingTag || _vm.isMergingExistingTags
                          ? _c(
                              "div",
                              {
                                staticClass: "inline-flex items-center m-l-sm",
                              },
                              [_vm._v("to:")]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "w-full tags-panel__form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "add-tags-form",
                  class: _vm.$hasErrorClass(_vm.$v.name, "form-group"),
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-tags-form__column" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.name.$model,
                            expression: "$v.name.$model",
                          },
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          name: "name",
                          type: "text",
                          placeholder: "Tag name",
                        },
                        domProps: { value: _vm.$v.name.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.$v.name, "$model", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: { field: _vm.$v.name, label: "Name" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "add-tags-form__column add-tags-form__column--cta m-l-sm",
                    },
                    [
                      _c(
                        "ladda-button",
                        {
                          staticClass: "btn btn-block btn-primary btn-block",
                          attrs: {
                            type: "submit",
                            click: _vm.handleActionButtonCallback,
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.action) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _vm.hasTagType
                  ? _c(
                      "div",
                      {
                        staticClass: "w-1/2 margin-t-2",
                        class: _vm.$hasErrorClass(_vm.$v.tagType, "form-group"),
                      },
                      [
                        _c("selectize", {
                          staticClass:
                            "selectize selectize-single form-control",
                          attrs: {
                            name: "tag_type",
                            placeholder: "Tag type",
                            options: _vm.tagTypeOptions,
                            disabled:
                              this.$route.query.entity ===
                                "interest-categories" && !!this.tagTypeText,
                            "disable-delete": true,
                          },
                          model: {
                            value: _vm.$v.tagType.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.tagType, "$model", $$v)
                            },
                            expression: "$v.tagType.$model",
                          },
                        }),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: { field: _vm.$v.tagType, label: "Tag type" },
                        }),
                        _vm._v(" "),
                        this.$route.query.entity === "interest-categories" &&
                        this.tagType
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "cursor-pointer pull-right help-block",
                                on: {
                                  click: () => {
                                    _vm.$v.tagType.$model = null
                                  },
                                },
                              },
                              [_vm._v("Clear")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasTagType &&
                this.$route.query.entity === "interest-categories"
                  ? _c(
                      "div",
                      {
                        staticClass: "spacer-x-2",
                        staticStyle: { "margin-top": "28px" },
                      },
                      [_c("strong", [_vm._v("OR")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasTagType &&
                this.$route.query.entity === "interest-categories"
                  ? _c(
                      "div",
                      {
                        staticClass: "w-1/2 margin-t-2",
                        class: _vm.$hasErrorClass(
                          _vm.$v.tagTypeText,
                          "form-group"
                        ),
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.tagTypeText.$model,
                              expression: "$v.tagTypeText.$model",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            name: "tag_type_text",
                            placeholder: "New tag type...",
                            disabled:
                              this.$route.query.entity ===
                                "interest-categories" &&
                              !!this.$v.tagType.$model,
                          },
                          domProps: { value: _vm.$v.tagTypeText.$model },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.tagTypeText,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          attrs: {
                            field: _vm.$v.tagTypeText,
                            label: "New tag type",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.showMergeIntoOptions
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "tags-panel__action control-label" },
                      [_vm._v("Or merge into")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showMergeIntoOptions
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "w-1/2 margin-t-2",
                        class: _vm.$hasErrorClass(
                          _vm.$v.mergeInto,
                          "form-group"
                        ),
                      },
                      [
                        _c("selectize", {
                          staticClass:
                            "selectize selectize-single form-control",
                          attrs: {
                            name: "merge_into",
                            placeholder: "Merge into",
                            options: _vm.mergeIntoOptions,
                            disabled: !(this.$route.query.entity === "career"),
                            "disable-delete": true,
                          },
                          model: {
                            value: _vm.$v.mergeInto.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.mergeInto, "$model", $$v)
                            },
                            expression: "$v.mergeInto.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "margin-t-2 m-l-sm" },
                      [
                        _c(
                          "ladda-button",
                          {
                            staticClass: "btn btn-block btn-primary btn-block",
                            attrs: {
                              type: "submit",
                              click: _vm.handleMergeInto,
                            },
                          },
                          [_vm._v("\n              Merge Into\n            ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }